import React, { useEffect, useState } from "react";
import { Select, Spin } from "antd";
import Swal from "sweetalert2";
import {
  ADD_EQUIP,
  getApiBaseUrl,
  ADD_ACTIVITY,
  GET_BLOCKS,
} from "../../Config/Config";

const { Option } = Select;

const AddWashingEquip = () => {
  const [blockOptions, setBlockOptions] = useState([]);
  const [formData, setFormData] = useState({
    EquipmentName: "",
    SerialNumber: "",
  });

  const [loading, setLoading] = useState(false);
  const user = JSON.parse(sessionStorage.getItem("user"));

  const [selectedBlock, setSelectedBlock] = useState(null);

  const fetchBlocks = async () => {
    try {
      const response = await fetch(`${getApiBaseUrl()}${GET_BLOCKS}`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      const blocks = result?.ResultData || [];
      setBlockOptions(blocks);
    } catch (err) {
      console.error("Failed to fetch blocks:", err);
    }
  };

  useEffect(() => {
    fetchBlocks();
  }, []);

  const handleBlockChange = (value) => {
    setSelectedBlock(value);
    setFormData((prev) => ({
      ...prev,
      blockid: value,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const parsedValue = name === "CreatedBy" ? parseInt(value, 10) : value;

    setFormData((prev) => ({
      ...prev,
      [name]: parsedValue,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      ...formData,
      Isdryer: 0,
      CreatedBy: user?.UserID,
      blockid: selectedBlock,
    };

    const logActivity = async (isSuccess, note) => {
      try {
        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ActivityType: 1, // Adjust if needed
            PerformedBy: user?.UserID,
            PerformedOn: new Date()
              .toISOString()
              .slice(0, 19)
              .replace("T", " "),
            Notes: note,
            Location: "Add Wash Equipment",
            IsSucces: isSuccess ? 1 : 0,
          }),
        });
      } catch (err) {
        console.error("Activity log failed:", err);
      }
    };

    try {
      const response = await fetch(`${getApiBaseUrl()}${ADD_EQUIP}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      setLoading(false);

      if (result?.Status) {
        await logActivity(
          true,
          `Wash Equipment added successfully: ${formData.EquipmentName || ""}`
        );
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Wash Equipment added successfully!",
        }).then(() => {
          window.location.reload();
        });
      } else {
        await logActivity(
          false,
          `Wash Equipment add failed: API responded false`
        );
        throw new Error("API responded with failure.");
      }
    } catch (error) {
      setLoading(false);
      await logActivity(false, `Wash Equipment add failed: ${error.message}`);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while submitting the form.",
      });
    }
  };

  const clearData = () => {
    setFormData({ EquipmentName: "", SerialNumber: "", selectedBlock: null });
  };

  useEffect(() => {
    const offcanvas = document.getElementById("AddWashingEquipOffcanvas");
    if (offcanvas) {
      const handleClose = () => {
        clearData();
      };
      offcanvas.addEventListener("hidden.bs.offcanvas", handleClose);
      return () => {
        offcanvas.removeEventListener("hidden.bs.offcanvas", handleClose);
      };
    }
  }, []);

  return (
    <>
      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)", // subtle tint
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="AddWashingEquipOffcanvas"
      >
        <form onSubmit={handleSubmit}>
          <div className="offcanvas-header">
            <h5 className="offcanvas-title me-4">Add Washing Equipment</h5>
            <div className="d-flex align-items-center ms-auto">
              <button
                type="submit"
                className="btn btn-sm btn-outline-success me-2"
                title="Save"
              >
                <i className="fa fa-check fs-4"></i>
              </button>
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                onClick={clearData}
              ></button>
            </div>
          </div>
          <div className="offcanvas-body">
            <div className="mb-3">
              <label className="form-label">Equipment Name</label>
              <span className="text-danger ms-1">*</span>
              <input
                type="text"
                className="form-control"
                name="EquipmentName"
                placeholder="Enter Equipment Name"
                value={formData.EquipmentName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Serial Number</label>
              <span className="text-danger ms-1">*</span>
              <input
                type="text"
                className="form-control"
                name="SerialNumber"
                placeholder="Enter Serial Number"
                value={formData.SerialNumber}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label ">Block</label>
              <span className="text-danger ms-1">*</span>

              <Select
                showSearch
                placeholder="Select a Block"
                optionFilterProp="children"
                onChange={handleBlockChange}
                value={selectedBlock}
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
                aria-required
              >
                {blockOptions.map((block) => (
                  <Option key={block.BlockId} value={block.BlockId}>
                    {block.BlockName}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddWashingEquip;
